import {
  GET_WP_COLLECT_LIST,
  GET_WP_SETUP_LIST,
  GET_WP_MINE_PAY_LIST,
  CANCEL_WP_MINE_COLLECTORSETUP,
  GET_WP_VIP_STATE,
  GET_WP_TURN_LIST,
  CANCEL_MINE_TURN,
  GET_WP_GROUP_LIST,
  OPEN_GROUP_LIST,
  SET_CHOICE_LIST,
  SET_EQUITY_VIP,
  WP_IS_NEED_UPDATE_VIP,
  SET_SHOW_LIST,
  SET_SHOW_WP_EXCHANGE,
  GET_WP_EXCHANGE_RESULT,
  SET_SHOW_WP_RESULT,
} from '../constants/wallpaperPay';

// 壁纸我的
export const getMineCollectList = payload => ({
  type: GET_WP_COLLECT_LIST,
  payload,
});

export const getMineSetupList = payload => ({
  type: GET_WP_SETUP_LIST,
  payload,
});
export const getMinePayList = payload => ({
  type: GET_WP_MINE_PAY_LIST,
  payload,
});

export const cancelMineCollectOrSetup = payload => ({
  type: CANCEL_WP_MINE_COLLECTORSETUP,
  payload,
});

export const getVipState = payload => ({
  type: GET_WP_VIP_STATE,
  payload,
});

export const getTurnList = payload => ({
  type: GET_WP_TURN_LIST,
  payload,
});

export const cancelMineTurn = payload => ({
  type: CANCEL_MINE_TURN,
  payload,
});

export const getGroupList = payload => ({
  type: GET_WP_GROUP_LIST,
  payload,
});

export const openGroup = payload => ({
  type: OPEN_GROUP_LIST,
  payload,
});

export const setChoiceList = payload => ({
  type: SET_CHOICE_LIST,
  payload,
});

export const setEquityVip = payload => ({
  type: SET_EQUITY_VIP,
  payload,
});

export const isNeedUpdateVip = payload => ({
  type: WP_IS_NEED_UPDATE_VIP,
  payload,
});

export const setShowList = payload => ({
  type: SET_SHOW_LIST,
  payload,
});

export const setShowWpExchange = payload => ({
  type: SET_SHOW_WP_EXCHANGE,
  payload,
});

export const getWpExchangeResult = payload => ({
  type: GET_WP_EXCHANGE_RESULT,
  payload,
});

export const setWpResultShow = payload => ({
  type: SET_SHOW_WP_RESULT,
  payload,
});
